export const CycleIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 7h-5V2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 17h5v5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 7a8 8 0 0 0-14-3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M4 17a8 8 0 0 0 14 3" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
